export default __webpack_public_path__ + "static/media/Home.7d6f8a36.svg";